/**
 * @generated SignedSource<<7204baa0a90bac807bf2ae936b9cd1e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type parentLink_user$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"UserName_user">;
  readonly " $fragmentType": "parentLink_user";
};
export type parentLink_user$key = {
  readonly " $data"?: parentLink_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"parentLink_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "parentLink_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserName_user"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "43597fea788f5f48d534470b73a91592";

export default node;
